import { render, staticRenderFns } from "./ComprobanteAperturaPage.vue?vue&type=template&id=4a8f986b"
import script from "./ComprobanteAperturaPage.js?vue&type=script&lang=js&external"
export * from "./ComprobanteAperturaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports